// src/utils/whatsapp.js

/**
 * Servis formu PDF'ini sunucuya kaydeder ve PDF bağlantısını
 * içeren WhatsApp mesajını açar.
 *
 * Teknisyen kendi cihazındaki WhatsApp hesabından gönderir.
 * Sistem merkezi bir WhatsApp hesabına bağlanmaz.
 */
export const sendServisFormViaWhatsApp = async ({
  formData,
  fotograflar = [],
  createPdfBlob,
}) => {
  if (!formData?.tel) {
    alert('Lütfen müşteri telefon numarasını girin.');
    return;
  }

  // Telefon numarasını yalnızca rakamlardan oluşan hale getir.
  let phoneWithCountry = String(formData.tel).replace(/\D/g, '');

  // 0090... biçimini 90... biçimine çevir.
  if (phoneWithCountry.startsWith('00')) {
    phoneWithCountry = phoneWithCountry.slice(2);
  }

  // 05XXXXXXXXX -> 905XXXXXXXXX
  if (
    phoneWithCountry.length === 11 &&
    phoneWithCountry.startsWith('0')
  ) {
    phoneWithCountry = `90${phoneWithCountry.slice(1)}`;
  }
  // 5XXXXXXXXX -> 905XXXXXXXXX
  else if (phoneWithCountry.length === 10) {
    phoneWithCountry = `90${phoneWithCountry}`;
  }

  if (!/^[1-9]\d{9,14}$/.test(phoneWithCountry)) {
    alert(
      'Lütfen geçerli bir telefon numarası girin.\n' +
        'Örnek: 05XXXXXXXXX veya +905XXXXXXXXX'
    );
    return;
  }

  if (typeof createPdfBlob !== 'function') {
    alert('PDF oluşturma fonksiyonu bulunamadı.');
    return;
  }

  try {
    // Önce PDF oluşturulur.
    const { blob, dosyaAdi } = await createPdfBlob();

    if (!blob || typeof dosyaAdi !== 'string' || !dosyaAdi.trim()) {
      throw new Error('PDF oluşturulamadı veya dosya adı alınamadı.');
    }

    // PDF sunucuya yüklenir.
    const formDataForUpload = new FormData();

    formDataForUpload.append('pdf', blob, dosyaAdi);
    formDataForUpload.append(
      'formData',
      JSON.stringify({
        ...formData,
        fotograflar,
      })
    );

    const response = await fetch('/api/servis-formu/pdf-kaydet', {
      method: 'POST',
      body: formDataForUpload,
    });

    const contentType = response.headers.get('content-type') || '';

    if (!contentType.toLowerCase().includes('application/json')) {
      throw new Error(
        `PDF kaydetme servisi beklenen JSON yanıtını döndürmedi ` +
          `(HTTP ${response.status}).`
      );
    }

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result?.hata ||
          result?.error ||
          `PDF kaydedilemedi (HTTP ${response.status}).`
      );
    }

    const pdfUrl = result?.url;

    if (typeof pdfUrl !== 'string' || !pdfUrl.trim()) {
      throw new Error('Sunucudan PDF bağlantısı alınamadı.');
    }

    // Backend "/servis-forumlari/dosya.pdf" veya tam URL döndürebilir.
    const resolvedPdfUrl = new URL(
      pdfUrl.trim(),
      `${window.location.origin}/`
    );

    if (
      resolvedPdfUrl.protocol !== 'https:' &&
      resolvedPdfUrl.protocol !== 'http:'
    ) {
      throw new Error('Sunucudan geçersiz bir PDF bağlantısı döndü.');
    }

    const fullPdfUrl = resolvedPdfUrl.href;

    console.log('Sunucudan gelen PDF adresi:', pdfUrl);
    console.log('WhatsApp üzerinden paylaşılacak PDF adresi:', fullPdfUrl);

    const dosyaAdiGoster = dosyaAdi
      .replace(/_/g, ' ')
      .replace(/\.pdf$/i, '')
      .replace(/\b\w/g, (harf) => harf.toUpperCase());

    const message =
      `Merhaba, ${formData.firmaIsmi || 'sayın müşteri'} için ` +
      `servis formunuz hazırlanmıştır.\n\n` +
      `📄 *${dosyaAdiGoster}*\n\n` +
      `PDF dosyasını görüntülemek veya indirmek için ` +
      `aşağıdaki bağlantıya tıklayın:\n${fullPdfUrl}\n\n` +
      `İyi çalışmalar dileriz.\n\nAir Makina`;

    const whatsappUrl =
      `https://wa.me/${phoneWithCountry}` +
      `?text=${encodeURIComponent(message)}`;

    // Mobilde popup/boş sekme engellenmesini önlemek için
    // mevcut sekmeden doğrudan WhatsApp'a geçilir.
    window.location.href = whatsappUrl;
  } catch (err) {
    console.error('WhatsApp gönderme hatası:', err);

    alert(
      '❌ WhatsApp mesajı hazırlanamadı:\n' +
        (err?.message || 'Bilinmeyen hata')
    );
  }
};